import { render, staticRenderFns } from "./cardTemplateVip05.vue?vue&type=template&id=18cbaaf0&scoped=true&"
import script from "./cardTemplateVip05.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip05.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip05.vue?vue&type=style&index=0&id=18cbaaf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cbaaf0",
  null
  
)

export default component.exports